import { FC } from "preact/compat";
import { TooltipProps } from "./interfaces";

const Tooltip: FC<TooltipProps> = ({
    action,
    "tooltip-content": tooltipContent,
    content,
}) => (
    <span
        className="d-tooltip"
        {...(tooltipContent && {
            "data-tooltip": tooltipContent,
        })}
        {...(action && {
            "data-d-action": action,
        })}
    >
        {content}
    </span>
);

export default Tooltip;
